import { useQuery } from '@tanstack/react-query';
import { getApproaches } from '../../../api/Approaches/approaches';
import { ApproachType } from '../../../utility/types';
export function useGetApproaches() {
  const getQuery = useQuery({
    queryKey: [ 'getApproaches' ],
    queryFn: () => getApproaches()
  });

  return {
    data: getQuery.data?.data.results as ApproachType[] || null, // Access response.data
    error: getQuery.error || null, // Access error
    isLoading: getQuery.isLoading,
    isPending: getQuery.isPending,
    refetch: getQuery.refetch
  };
}
